/**
 * @generated SignedSource<<fdadbdaf4b09188b4fdf178e400700d2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutSidebarSidemarkPane_transaction$data = {
  readonly sidemark: {
    readonly content: string | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutSidebarSidemarkForm_transaction">;
  readonly " $fragmentType": "CheckoutSidebarSidemarkPane_transaction";
};
export type CheckoutSidebarSidemarkPane_transaction$key = {
  readonly " $data"?: CheckoutSidebarSidemarkPane_transaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutSidebarSidemarkPane_transaction">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutSidebarSidemarkPane_transaction",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutSidebarSidemarkForm_transaction"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Note",
      "kind": "LinkedField",
      "name": "sidemark",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "content",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Transaction",
  "abstractKey": null
};

(node as any).hash = "327d23c2b60124509122fc41604f3a2c";

export default node;
